import React from 'react';
import { BarChart, Cell, ResponsiveContainer, XAxis, Bar, Text, YAxis } from 'recharts';
import { iucnStatusData } from 'src/shared/helpers/iucnStatusHelper';

export type IucnChartDatum = {
    iucnRedListCategory: string;
    count: number;
};

type Props = {
    chartData: IucnChartDatum[];
    className?: string;
};

const IucnSpeciesChart = ({ chartData, className }: Props) => {
    const iucnOrderMap: Record<string, number> = { CR: 0, EN: 1, VU: 2, NT: 3 };
    const sortedChartData = React.useMemo(
        () =>
            [...(chartData || [])].sort(
                (a, b) => (iucnOrderMap[a.iucnRedListCategory] ?? 99) - (iucnOrderMap[b.iucnRedListCategory] ?? 99)
            ),
        [chartData]
    );

    return (
        <div className={className}>
            {sortedChartData && sortedChartData.length > 0 && (
                <div className='flex'>
                    <div className='h-[105px] w-[260px]'>
                        <ResponsiveContainer width='100%' height='100%'>
                            <BarChart data={sortedChartData} margin={{ top: 0, bottom: 0, right: 15 }} layout='vertical'>
                                <XAxis type='number' hide />
                                <YAxis
                                    type='category'
                                    width={145}
                                    dataKey='iucnRedListCategory'
                                    tick={<CustomTick />}
                                    tickLine={false}
                                    dx={-15}
                                    interval={0}
                                    fontSize={15}
                                />
                                <Bar dataKey='count' radius={[0, 4, 4, 0]} barSize={14} label={{ position: 'right' }}>
                                    {sortedChartData.map((entry, index) => (
                                        <Cell key={`cell-${index}`} fill={entry.iucnRedListCategory === 'NT' ? '#CF8515' : '#AD180E'} />
                                    ))}
                                </Bar>
                            </BarChart>
                        </ResponsiveContainer>
                    </div>
                    <div className='relative mt-[3px] w-[6px] h-[70px] border-r border-y border-red-100 rounded-r-sm'>
                        <div className='absolute text-red-100 mt-6 ml-1'>-</div>
                    </div>
                    <div className='flex items-center text-red-100 text-xs ml-3 h-[70px] mt-1'>
                        Threatened
                        <br />
                        species
                    </div>
                </div>
            )}
        </div>
    );
};

// Used `any` type because the recharts tick expected the props to be `any`
const CustomTick = ({ x, y, payload }: any) => {
    const iucnLabel = `${iucnStatusData[payload.value]?.label?.replace('Critically', 'Crit.')} (${payload.value})`;
    return (
        <Text width={180} x={x} y={y} textAnchor='end' verticalAnchor='middle' className='text-xs text-grey-80'>
            {iucnLabel}
        </Text>
    );
};

export default IucnSpeciesChart;
